import React from 'react'
import './ButtonGroup.less'

// TODO: replace any with something denoting Button types
const ButtonGroup = ({ children }: { children: any }) => {
  return <div className="ButtonGroup">{children}</div>
}

export default ButtonGroup
